import {createRouter, createWebHistory} from 'vue-router';
import {isAuthenticated} from './composables/useAuth';

const PublicLayout = () => import('./views/layout/PublicLayout');
const ActivationPage = () => import('./views/auth/ActivationPage');
const LoginPage = () => import('./views/auth/LoginPage');
const ForgotPassword = () => import('./views/auth/ForgotPassword');
const ResetPassword = () => import('./views/auth/ResetPassword');
const Dashboard = () => import('./views/Dashboard');
const Layout = () => import('./views/layout/Layout');
const InspectionIndex = () => import('./views/inspections/InspectionIndex');
const InspectionShow = () => import('./views/inspections/InspectionShow');
const CustomerIndex = () => import('./views/customers/CustomerIndex');
const CustomerShow = () => import('./views/customers/CustomerShow');
const CarIndex = () => import('./views/cars/CarIndex');
const CarShow = () => import('./views/cars/CarShow');
const Setting = () => import('./views/setting/Setting');
const SetIndex = () => import('./views/sets/SetIndex');
const ServiceIndex = () => import('./views/services/ServiceIndex');
const PartIndex = () => import('./views/parts/PartIndex');
const PartCategoryIndex = () => import('./views/part_categories/PartCategoryIndex');
const CarClassIndex = () => import('./views/car_classes/CarClassIndex');
const UserIndex = () => import('./views/users/UserIndex');

const routes = [
  /**
   * ログイン不要画面
   * REVIEW: pathに「/」を設定することで、ログイン後ページとグループを分け、違うベースコンポーネントを利用している
   */
  {
    path: '/',
    name: 'public',
    component: PublicLayout,
    children: [
      { path: 'login', name: 'login', component: LoginPage },
      { path: 'register/activate/:token', name: 'register.activate', component: ActivationPage },
      { path: 'forgot-password', name: 'forgot-password', component: ForgotPassword },
      { path: 'password/reset/:token', name: 'reset-password', component: ResetPassword },
    ]
  },

  /**
   * ログイン後画面
   */
  {
    path: '',
    name: 'private',
    component: Layout,
    children: [
      // ダッシュボード
      { path: '', name: 'dashboard', component: Dashboard, },

      // 顧客
      { path: 'customers', name: 'customers.index', component: CustomerIndex, },
      { path: 'customers/:id', name: 'customers.show', component: CustomerShow, },

      // 車検
      { path: 'cars', name: 'cars.index', component: CarIndex, },
      { path: 'cars/:id', name: 'cars.show', component: CarShow, },


      // 車検
      { path: 'inspections', name: 'inspections.index', component: InspectionIndex, },
      { path: 'inspections/:id', name: 'inspections.show', component: InspectionShow, },

      // 基本設定
      { path: 'setting', name: 'setting', component: Setting },

      // 車両クラス
      { path: 'car-classes', name: 'car-classes.index', component: CarClassIndex, },

      // 車検セット
      { path: 'sets', name: 'sets.index', component: SetIndex, },

      // 作業
      { path: 'services', name: 'services.index', component: ServiceIndex, },

      // 部品カテゴリー
      { path: 'part-categories', name: 'part-categories.index', component: PartCategoryIndex, },

      // 部品
      { path: 'parts', name: 'parts.index', component: PartIndex, },

      // ユーザー
      { path: 'users', name: 'users', component: UserIndex, },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

/**
 * ログイン状態に応じてリダイレクトさせるための設定
 */
router.beforeEach((to, from) => {
  // ログイン済みの場合、ログインページへのアクセスをダッシュボードにリダイレクト
  // if (to.path === '/login' && isAuthenticated()) {
  //   return from.path !== '/login' ? from.path : '/';
  // }

  // 未ログインの場合、非公開画面へのアクセスをログインページにリダイレクト
  if (to.matched[0]?.name === 'private' && !isAuthenticated()) {
    return '/login';
  }
});

export default router;
